import React from 'react';

export const ProgressStep = (props: {
    steps: number;
    currentStep: number;
    onClick?: (value: number) => void;
}) => {
    const stepsArray = Array.from({ length: props.steps }, (_, index) => index);
    return (
        <div style={{ display: 'flex' }}>
            {stepsArray.map((element) => (
                <div
                    className="button-style"
                    onClick={() => {
                        if (props.onClick) props.onClick(element);
                    }}
                    key={element}
                    style={{
                        marginRight: element === stepsArray.length ? 0 : 16,
                        height: 8,
                        width: 8,
                        background: element === props.currentStep ? '#4BCAE5' : '#D0D3D8',
                        borderRadius: 100,
                    }}
                />
            ))}
        </div>
    );
};
